import React, { useEffect, useState } from 'react';

const InstallButton = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            setDeferredPrompt(e); // Save the event
            setIsInstallable(true); // Show the install button
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt(); // Show the prompt

            await deferredPrompt.userChoice;

            setDeferredPrompt(null); // Clear it after use
            setIsInstallable(false);
        }
    };

    return (
        <>
            {isInstallable && (
                <div className="single-footer-widget">
                    <br/>
                    <h6>Install our App</h6>
                    <div className='install-button'>
                        <i onClick={handleInstallClick} className="fa-solid fa-arrow-up-right-from-square"></i>
                    </div>
                </div>
            )}
        </>
    );
};

export default InstallButton;
